"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * DisplayName,Valueの配列からKeyに一致するDisplayNameを取得する。
 * @param {array} array - DisplayName,Valueの配列
 * @param {string} array.displayName - 表示名
 * @param {number|string} array.value - 値
 * @param {number|string} value　- 選択されている値
 */
const getDisplayName = function (array, value) {
  const found = array.find(function (element) {
    return element.value === value;
  });
  if (found) {
    return found.displayName;
  }
  return '';
};
var _default = exports.default = getDisplayName;